import { ThemeProvider, CssBaseline } from '@mui/material';
import { AppProvider } from '@/contexts/AppContext';
import { MockDataProvider } from '@/contexts/MockDataContext';
import { NodeConfigProvider } from '@/utils/nodeConfig';
import { AppRouter } from '@/router';
import ErrorBoundary from '@/components/common/ErrorBoundary';
import theme from '@/theme';

export default function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AppProvider>
          <MockDataProvider>
            <NodeConfigProvider>
              <AppRouter />
            </NodeConfigProvider>
          </MockDataProvider>
        </AppProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
